// Actions
export const setOnboardingProcesses = ({ commit }, payload) => {
  commit('SET_ONBOARDING_PROCESSES', payload)
}
export const addOnboardingProcesses = ({ commit }, payload) => {
  commit('ADD_ONBOARDING_PROCESSES', payload)
}
export const setOnboardingProcessesLoading = ({ commit }, payload) => {
  commit('SET_ONBOARDING_PROCESSES_LOADING', payload)
}

export const setAccountMigrations = ({ commit }, payload) => {
  commit('SET_ACCOUNT_MIGRATIONS', payload)
}
export const addAccountMigrations = ({ commit }, payload) => {
  commit('ADD_ACCOUNT_MIGRATIONS', payload)
}
export const setAccountMigrationsLoading = ({ commit }, payload) => {
  commit('SET_ACCOUNT_MIGRATIONS_LOADING', payload)
}

export const setCustodyTransfers = ({ commit }, payload) => {
  commit('SET_CUSTODY_TRANSFERS', payload)
}
export const addCustodyTransfers = ({ commit }, payload) => {
  commit('ADD_CUSTODY_TRANSFERS', payload)
}
export const setCustodyTransfersLoading = ({ commit }, payload) => {
  commit('SET_CUSTODY_TRANSFERS_LOADING', payload)
}

export const setAveragePriceRequests = ({ commit }, payload) => {
  commit('SET_AVERAGE_PRICE_REQUESTS', payload)
}
export const addAveragePriceRequests = ({ commit }, payload) => {
  commit('ADD_AVERAGE_PRICE_REQUESTS', payload)
}
export const setAveragePriceRequestsLoading = ({ commit }, payload) => {
  commit('SET_AVERAGE_PRICE_REQUESTS_LOADING', payload)
}

export const setFeeBillingBatches = ({ commit }, payload) => {
  commit('SET_FEE_BILLING_BATCHES', payload)
}
export const addFeeBillingBatches = ({ commit }, payload) => {
  commit('ADD_FEE_BILLING_BATCHES', payload)
}
export const setFeeBillingBatchesLoading = ({ commit }, payload) => {
  commit('SET_FEE_BILLING_BATCHES_LOADING', payload)
}

export const setProfessionals = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS', payload)
}
export const addProfessionals = ({ commit }, payload) => {
  commit('ADD_PROFESSIONALS', payload)
}
export const setProfessionalsLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS_LOADING', payload)
}

export const setClientSwaps = ({ commit }, payload) => {
  commit('SET_CLIENT_SWAPS', payload)
}
export const addClientSwaps = ({ commit }, payload) => {
  commit('ADD_CLIENT_SWAPS', payload)
}
export const setClientSwapsLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_SWAPS_LOADING', payload)
}

